import { Row } from 'shared/components/other';
import { LogItem } from 'types/cabinetCopying';

export const convertToTableRows = <T extends LogItem>(data: T[]): Row<T>[] =>
  data.map((x, index) => ({
    data: x,
    rowId: String(index),
    children: null,
  }));
